import { queryOptions } from '@tanstack/react-query'

import {
  getSubscribeFilters,
  getSubscribeList,
  getSubscribeListNoAuth,
  GetSubscribeListParams,
} from './subscribe-v2.api'

export const subscribeV2Queries = {
  all: ['subscribeV2'],

  // Query Keys
  filtersQueryKey: () => [...subscribeV2Queries.all, 'filters', 'KR_PRODUCT_V1'],
  listQueryKey: (params: GetSubscribeListParams, isAuthenticated: boolean, bearerToken?: string) => [
    ...subscribeV2Queries.all,
    'list',
    'KR_PRODUCT_V1',
    params,
    { isAuthenticated, bearerToken },
  ],

  // Query Options
  filters: () =>
    queryOptions({
      queryKey: subscribeV2Queries.filtersQueryKey(),
      queryFn: async () => {
        const response = await getSubscribeFilters(true)
        return response.data
      },
      staleTime: 1000 * 60 * 60, // 1시간 캐시
    }),

  // 비로그인 회원용 상품 리스트 (appliedCoupon: null)
  listNoAuth: (params: GetSubscribeListParams) =>
    queryOptions({
      queryKey: subscribeV2Queries.listQueryKey(params, false),
      queryFn: async () => {
        const response = await getSubscribeListNoAuth(params, true)
        return response.data
      },
    }),

  // 로그인 회원용 상품 리스트 (appliedCoupon 포함)
  list: (params: GetSubscribeListParams, bearerToken?: string) =>
    queryOptions({
      queryKey: subscribeV2Queries.listQueryKey(params, true, bearerToken),
      queryFn: async () => {
        const response = await getSubscribeList(params, bearerToken, true)
        return response.data
      },
    }),
} as const
